module.exports = "/static/assets/73557b737d416858232754c5c6b20b90.png";